import {useUniversalFetch} from '#imports';

export type SearchableLanguage = {
    code: string;
    name: string;
};

export default class LanguageSearcher {
    searchableLanguages: SearchableLanguage[] = [];

    async loadLanguages(): Promise<void> {
        if (this.searchableLanguages.length > 0) {
            return;
        }

        const seed = new Date();

        const data = await useUniversalFetch<SearchableLanguage[]>(`/api/language?randomseed=${seed.getMilliseconds()}`);

        if (data) {
            this.searchableLanguages = data;
        }
    }

    search(query: string): SearchableLanguage[] {
        return this.searchableLanguages.filter((lang) => this.sanitize(lang.name).includes(this.sanitize(query)));
    }

    getCodeByName(languageName: string): string {
        return this.searchableLanguages.filter((lang) => this.sanitize(lang.name) === this.sanitize(languageName))[0].code;
    }

    findByCode(languageCode: string): SearchableLanguage | null {
        const languagesFound = this.searchableLanguages.filter((lang) => this.sanitize(lang.code) === this.sanitize(languageCode));
        if (languagesFound.length === 1) {
            return languagesFound[0];
        }
        return null;
    }

    sanitize(lang: string): string {
        if (!lang) {
            return '';
        }

        return lang
            .normalize('NFD')
            .replace(/[\u0300-\u036F]/g, '')
            .toLowerCase();
    }
}
